var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPickupDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -412) translate(16 393) translate(16 12) translate(0 4) translate(0 3.893)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4.107,
    fill: "#009B62",
    rx: 4,
    ry: 4.107
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.514 4.107c.1 0 .178-.046.234-.134L3.942.397C3.984.327 4 .274 4 .219 4 .087 3.916 0 3.789 0c-.093 0-.144.031-.2.123L1.504 3.562.423 2.096c-.059-.084-.117-.118-.2-.118-.132 0-.223.094-.223.226 0 .055.023.118.067.175l1.205 1.589c.07.093.142.14.242.14z",
    transform: "translate(2 2.054)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPickupDone);
export default __webpack_public_path__ + "static/media/icon-pickup-done.2a904aecca413bfb742aa82b6c480222.svg";
export { ForwardRef as ReactComponent };